export const DeclOfNumMixin = {
    methods: {
        declOfNum(n, words) {
            return words[(n % 100 > 4 && n % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(n % 10 < 5) ? Math.abs(n) % 10 : 5]];
        },
    }
}